import { Box, Typography, TextField, Grid } from "@mui/material";
import PrimaryBaseButton from "../../../main/components/PrimaryBaseButton";
import { ClientDetailsFooter } from "./ClientDetailsFooter";
import { useState, useEffect } from "react";
import { Client } from "../types";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { clientsApi } from "../../../services/api";

export default function ClientDetailsFooterPage(props: { client: Client | null }) {
  const [whatsAppsAmount, setWhatsAppsAmount] = useState<number>(0);
  const [openSuccessWhatsAppAmountModal, setOpenSuccessWhatsAppAmountModal] =
    useState(false);
  const [
    openEditConfirmationWhatsAppAmoutModal,
    setOpenEditConfirmationWhatsAppAmoutModal,
  ] = useState(false);

  const minWhatsAppAmount = props.client?.collaboratorsList?.filter(
    (item) => item.whatsappEnabled === true
  ).length;

  const onConfirmWhatsAppAmount = async () => {
    setOpenEditConfirmationWhatsAppAmoutModal(false);
    if (props.client) {
      await clientsApi.pathClientWhatsAppAmount(props.client.id, whatsAppsAmount);
    }
  };
  const [openErrorWhatsAppAmountModal, setOpenErrorWhatsAppAmountModal] =
    useState(false);

  useEffect(() => {
    if (props.client) {
      setWhatsAppsAmount(props.client.permittedWhatsappNumbers ?? 0);
    }
  }, [props.client]);

  return (
    <>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginBottom: "16px",
        }}
      >
        <Typography
          sx={{
            textAlign: "left",
            fontSize: { xs: "13px", md: "16px" },
          }}
        >
          Quantidade de WhatsApps cadastrados permitidos:
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            rowGap: { xs: "8px" },
          }}
        >
          <TextField
            inputProps={{
              min: minWhatsAppAmount,
              max: props.client?.plan?.maxWhatsappNumbers,
            }}
            value={whatsAppsAmount}
            onChange={(e) => {
              var value = parseInt(e.target.value);
              if (
                props.client?.plan &&
                value > props.client?.plan.maxWhatsappNumbers
              )
                value = props.client?.plan.maxWhatsappNumbers;
              if (minWhatsAppAmount && value < minWhatsAppAmount)
                value = minWhatsAppAmount;
              setWhatsAppsAmount(value);
            }}
            type="number"
            sx={{
              "& .MuiOutlinedInput-root": {
                marginLeft: "20px",
                borderRadius: "4px",
                height: "40px",
                width: "75px",
              },
            }}
          />
          {whatsAppsAmount !== props.client?.permittedWhatsappNumbers && (
            <PrimaryBaseButton
              sx={{ height: "30px", marginLeft: "20px" }}
              title="Salvar"
              onClick={() =>
                setOpenEditConfirmationWhatsAppAmoutModal(true)
              }
            />
          )}
        </Box>
      </Box>

      <Grid item sm={12} xs={12} sx={{ textAlign: "right" }}>
        <ClientDetailsFooter clientId={props.client?.id ?? ""} />
      </Grid>

      <ConfirmationModal
        open={openEditConfirmationWhatsAppAmoutModal}
        setOpen={setOpenEditConfirmationWhatsAppAmoutModal}
        title="Salvar nova Quantidade de WhatsApps cadastrados"
        contentText="Deseja mesmo salvar a nova quantidade de WhatsApps cadastrados?"
        onConfirm={onConfirmWhatsAppAmount}
        setOpenErrorModal={setOpenErrorWhatsAppAmountModal}
        setOpenSuccessModal={setOpenSuccessWhatsAppAmountModal}
      />
      <ActionAlert
        message="A quantidade de WhatsApps cadastrados foi alterada com sucesso"
        severity="success"
        open={openSuccessWhatsAppAmountModal}
        setOpen={setOpenSuccessWhatsAppAmountModal}
        onClose={() => {
          setOpenSuccessWhatsAppAmountModal(false);
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao alterar a quantidade de WhatsApps cadastrados"
        severity="error"
        open={openErrorWhatsAppAmountModal}
        setOpen={setOpenErrorWhatsAppAmountModal}
        onClose={() => {
          setOpenErrorWhatsAppAmountModal(false);
        }}
      />
    </>
  );
}
